import sopClassDictionary from '../util/sopClassDictionary';

/**
 * Checks whether dicom files with specified SOP Class UID are not readable
 * @param {string} SOPClassUID - SOP Class UID to be checked
 * @returns {boolean} - true if it is not readable
 */
export default function isNotReadable(SOPClassUID) {
  return SOPClassUID === sopClassDictionary.RawDataStorage;
}
